<template>
    <div class="fees">
        <base-card
            v-if="list"
            :addMargins="false"
            class="card--fees"
        >
            <template #card__title >
                <div class="fees__header display--flex">
                    <span class="fees__title capitalize">
                        {{ $t(`global.quotas`) }}
                    </span>
                    <div class="fees__actions">
                        <router-link
                            class="fees__actions__new-fee position--relative accessibility--pseudo accessibility--active"
                            :to="'/fees/add'">
                            <icon-plus/>
                        </router-link>
                    </div>
                </div>
            </template>
            <template #card__body >
                <base-table
                    v-if="list.length > 0"
                    class="table__fees"
                    :headers="[
                        { name: 'year', canSort: true, filterName: 'year' },
                        { name: 'type', canSort: false },
                        { name: 'subscription', canSort: false },
                    ]"
                    :list="list"
                    :pagination="pagination"
                    model="fee"
                    :settings="{
                        component: 'RowFees',
                        warning: $t('global.quotas')
                    }"
                />
                <div v-else class="fees__no-results">{{ $t('global.noResults') }}</div>
            </template>
        </base-card>
        <base-pagination
            v-if="pagination"
            class="table__pagination"
            :pagination="pagination"
        />
    </div>
</template>

<script>
// hooks
import { listStructure } from '@/hooks/use-data';

export default {
    ...listStructure,
    components: {
        ...listStructure.components,
        BaseCard: () => import( /* webpackChunkName: 'BaseCard' */ '@/components/bundles/cards/BaseCard' ),
        BasePagination: () => import( /* webpackChunkName: 'Pagination' */ '@/components/bundles/tables/packs/Pagination' ),
        IconPlus: () => import( /* webpackChunkName: 'IconPlus' */ '@/components/bundles/layout/images/icons/IconPlus' )
    },
    props: {
        ...listStructure.props
    }
};
</script>

<style lang="scss" scoped>
    .fees {
        max-width: 1350px;
        margin: 0 auto;
        @include responsive( max-width, 1450px ) {
           margin: 0 45px;
        }
        &__header {
            @include position-grid( center, space-between );
        }
        &__no-results {
            @include typography-specs( 18px, 22px );
            text-align: center;
            padding: 40px 0 20px;
        }
    }
</style>